import LabelWidgetForm from './LabelWidgetForm'

export default LabelWidgetForm;